import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

interface DataTableProps {
  data: any;
  header?: React.ReactNode;
  emptyMessage?: string;
  selectedRows?: any;
  expandedRows?: any;
  onSelectionChange?: any;
  loading?: boolean;
  children: any;
  actionColumn?: any;
  filters?: any;
  showCheckbox: boolean;
  rowExpansionTemplate?: any;
  onRowToggle?: any;
  isNotViewer?: any;
}

const CustomDataTable = ({
  data,
  header,
  emptyMessage,
  selectedRows,
  onSelectionChange,
  loading,
  children,
  actionColumn,
  filters,
  showCheckbox,
  expandedRows,
  rowExpansionTemplate,
  onRowToggle,
  isNotViewer,
}: DataTableProps) => {
  return (
    <DataTable
      dataKey="id"
      value={data}
      header={header}
      rows={5}
      stripedRows
      removableSort
      paginator
      rowsPerPageOptions={[5, 10, 25, 50]}
      filterDisplay="menu"
      filters={filters}
      emptyMessage={emptyMessage}
      selection={selectedRows}
      onSelectionChange={onSelectionChange}
      loading={loading}
      expandedRows={expandedRows}
      rowExpansionTemplate={rowExpansionTemplate}
      onRowToggle={onRowToggle}
    >
      <Column
        selectionMode={showCheckbox ? "multiple" : undefined}
        alignFrozen="left"
        frozen
      />
      {children}
      {isNotViewer() && <Column body={actionColumn} />}
    </DataTable>
  );
};

export default CustomDataTable;
